var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.84,
    height: 176.881,
    viewBox: "0 0 120.84 176.881",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    transform: "translate(-179 -220.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M-106.169-60.723a10.884,10.884,0,0,0-8.523-10.653V-78.3A16.6,16.6,0,0,0-131.2-94.813,16.6,16.6,0,0,0-147.716-78.3h0v6.925a11.355,11.355,0,0,0-8.523,10.653v21.839A10.923,10.923,0,0,0-145.053-27.7h27.7a10.923,10.923,0,0,0,11.186-11.186ZM-131.2-91.617A13.187,13.187,0,0,1-117.887-78.3v6.925h-26.1V-78.3C-144.52-85.758-138.661-91.617-131.2-91.617ZM-109.9-38.883a7.282,7.282,0,0,1-7.457,7.457h-27.7a7.282,7.282,0,0,1-7.457-7.457V-60.723a7.282,7.282,0,0,1,7.457-7.457h27.7a7.282,7.282,0,0,1,7.457,7.457ZM-131.2-55.4a5.911,5.911,0,0,0-5.859,5.859,6.232,6.232,0,0,0,4.261,5.859v5.859a1.412,1.412,0,0,0,1.6,1.6,1.412,1.412,0,0,0,1.6-1.6v-5.859a6.531,6.531,0,0,0,4.261-7.457A6.232,6.232,0,0,0-131.2-55.4Zm0,8.523a2.516,2.516,0,0,1-2.663-2.663A2.516,2.516,0,0,1-131.2-52.2a2.516,2.516,0,0,1,2.663,2.663A2.853,2.853,0,0,1-131.2-46.873Z",
    transform: "translate(370.624 359.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(179 220.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M-42.042-66.873V-32.1c0,40.706-23.368,60.383-41.468,75.58-7.479,6.3-14.041,11.8-17.4,17.636a1.712,1.712,0,0,1-.66.693,1.62,1.62,0,0,1-2.179-.6c-3.393-5.833-9.982-11.335-17.5-17.631C-139.413,28.356-162.882,8.68-162.882-32.1V-66.873a1.61,1.61,0,0,1,1.582-1.614c38.7,0,57.288-33.329,57.549-33.787a1.687,1.687,0,0,1,.6-.591,1.6,1.6,0,0,1,2.173.591c.032.1,18.654,33.787,57.352,33.787A1.613,1.613,0,0,1-42.042-66.873Zm-3.2,34.778V-65.323c-33.387-.762-52.105-25.483-57.117-33.126-5.012,7.644-23.767,32.365-57.325,33.126V-32.1c0,39.321,22.809,58.438,40.482,73.241,6.855,5.737,12.949,10.877,16.843,16.347,3.819-5.5,9.956-10.643,16.811-16.449C-67.951,26.279-45.243,7.162-45.243-32.1Z",
    transform: "translate(162.882 103.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M-140.044-71.264a1.617,1.617,0,0,1,1.619,1.614,1.611,1.611,0,0,1-1.619,1.582h-8.272a1.61,1.61,0,0,1-1.614-1.582,1.616,1.616,0,0,1,1.614-1.614Z",
    transform: "translate(218.92 240.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M-131.838-68.852a1.566,1.566,0,0,1-1.582,1.582h-17.732a1.587,1.587,0,0,1-1.587-1.582,1.614,1.614,0,0,1,1.587-1.614h17.732A1.589,1.589,0,0,1-131.838-68.852Z",
    transform: "translate(206.763 244.151)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkImg1);
export default __webpack_public_path__ + "static/media/work-img1.a56938513fee643febfaa6e6f4daa155.svg";
export { ForwardRef as ReactComponent };